
const CONSTANTS = {
    name: "Rostyslav Khoptiy"
};

export default CONSTANTS;